<template>
  <div class="page" v-if="campaign">
    <div class="page-main">
      <div class="page-header">
        <div class="col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1">
          <h1 class="page-title">Campaign</h1>
          <breadcrumb
            name="WSGT_DRIVE_EDIT"
            :withLast.sync="campaign.name"
          ></breadcrumb>
          <div class="page-title page-header-actions">
            <button
              type="button"
              class="btn btn-round btn-default mx-10"
              @click="goBack"
            >
              <i class="icon md-chevron-left" aria-hidden="true"></i>
              Back
            </button>
          </div>
        </div>
      </div>
      <div class="page-content container-fluid">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1">
            <div class="panel panel-bordered">
              <div class="panel-heading">
                <div class="panel-title">
                  <h4>Campaign Information - {{ campaign.id }}</h4>
                  <button
                    type="button"
                    class="btn btn-primary btn-round"
                    @click="gotoProgressUpdate"
                  >
                    Progress Update
                  </button>
                </div>
              </div>
              <div class="panel-body">
                <div class="form-horizontal" v-if="campaign">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <CampaignName :campaign="campaign" />
                    </div>
                    <div class="form-group col-md-3">
                      <StatusDropdown
                        :campaign="campaign"
                        @updated="fetchCampaign"
                      />
                    </div>
                  </div>
                  <hr />

                  <div class="row">
                    <div class="col-6 col-xs-12">
                      <CampaignInfo
                        :campaign="campaign"
                        @updated="fetchCampaign"
                      />
                    </div>
                  </div>
                  <hr />

                  <div class="row">
                    <div class="col-6 col-xs-12">
                      <MaxRewardPerStore
                        :campaign="campaign"
                        @updated="fetchCampaign"
                      />
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
              <div class="panel-footer">
                <div class="d-flex justify-content-between"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wsgtdriveService } from "@/api/client";

import CampaignName from "@/views/wsgtdrive/components/CampaignName.vue";
import CampaignInfo from "@/views/wsgtdrive/components/CampaignInfo.vue";
import StatusDropdown from "@/views/wsgtdrive/components/StatusDropdown.vue";
import MaxRewardPerStore from "@/views/wsgtdrive/components/MaxRewardPerStore.vue";

export default {
  name: "WSGTDriveEdit",

  components: {
    CampaignName,
    CampaignInfo,
    StatusDropdown,
    MaxRewardPerStore,
  },

  data() {
    return { campaign: null };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "WSGTDriveList" }).catch({});
    },

    async fetchCampaign() {
      const id = this.$route.params.id;
      this.campaign = await wsgtdriveService.getById(id);
    },

    gotoProgressUpdate() {
      this.$router
        .push({
          name: "WSGTDriveProgressUpdate",
          params: { id: this.campaign.id },
        })
        .catch((err) => {});
    },
  },

  async created() {
    await this.fetchCampaign();
  },
};
</script>

<style lang="scss" scoped>
.panel-bordered > .panel-heading {
  padding-top: 15px;
}

.panel-bordered > .panel-heading > .panel-title {
  padding-bottom: 10px;

  display: flex;
  justify-content: space-between;
}
</style>
